import { useQuery } from "react-query";
import {
  getConstant,
  getExpenseSummary,
  getIncomeSummary,
  getPurchaseExpenseSummary,
  Request_Summary,
} from "./service";

export const useGetConstant = () => {
  return useQuery({
    queryFn: () => getConstant(),
    queryKey: ["constant"],
  });
};

export const useGetIncomeSummary = ({
  end_date,
  start_date,
}: Request_Summary) => {
  return useQuery({
    queryKey: ["incomeSummary", end_date, start_date],
    queryFn: () => getIncomeSummary({ end_date, start_date }),
  });
};

export const useGetPurchaseExpenseSummary = ({
  end_date,
  start_date,
}: Request_Summary) => {
  return useQuery({
    queryKey: ["purchaseExpenseSummary", end_date, start_date],
    queryFn: () => getPurchaseExpenseSummary({ end_date, start_date }),
  });
};

export const useGetExpenseSummary = ({
  end_date,
  start_date,
}: Request_Summary) => {
  return useQuery({
    queryKey: ["ExpenseSummary", end_date, start_date],
    queryFn: () => getExpenseSummary({ end_date, start_date }),
  });
};
